export default "__VITE_ASSET__1fc1120d__"